import { render, staticRenderFns } from "./PayPalPaymentResult.vue?vue&type=template&id=322f02f6&scoped=true&"
import script from "./PayPalPaymentResult.vue?vue&type=script&lang=ts&"
export * from "./PayPalPaymentResult.vue?vue&type=script&lang=ts&"
import style0 from "./PayPalPaymentResult.vue?vue&type=style&index=0&id=322f02f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322f02f6",
  null
  
)

export default component.exports